/**
 * WCAG 2.2.2 Pause/Play button for auto-playing slideshows.
 * Loaded from layout/theme.liquid. Adds a pause/play toggle to any
 * <slide-show> element that has autoplay enabled and 2+ slides.
 *
 * Kept separate from slideshow.js so the Pinnacle file stays untouched
 * for clean theme upgrades.
 */
(function () {
  function addPauseButton(slideshow) {
    if (slideshow.dataset.pauseButtonAdded) return;

    var autoplay = slideshow.dataset.autoplay;
    if (autoplay === 'false' || !autoplay) return;

    var slides = slideshow.querySelectorAll('.carousel__slide');
    if (slides.length < 2) return;

    // Wait for Flickity to initialize
    var flkty = slideshow.flkty;
    if (!flkty) return;

    slideshow.dataset.pauseButtonAdded = 'true';
    slideshow.style.position = 'relative';

    var pauseBtn = document.createElement('button');
    pauseBtn.type = 'button';
    pauseBtn.className = 'slideshow-pause-btn';
    pauseBtn.setAttribute('aria-label', 'Pause slideshow');
    pauseBtn.innerHTML =
      '<svg class="slideshow-pause-btn__icon slideshow-pause-btn__icon--pause" width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><rect x="1" y="0" width="3.5" height="12" rx="0.5"/><rect x="7.5" y="0" width="3.5" height="12" rx="0.5"/></svg>' +
      '<svg class="slideshow-pause-btn__icon slideshow-pause-btn__icon--play" width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><polygon points="1,0 12,6 1,12"/></svg>';
    slideshow.appendChild(pauseBtn);

    var isPaused = false;
    pauseBtn.addEventListener('click', function () {
      if (isPaused) {
        flkty.playPlayer();
        pauseBtn.setAttribute('aria-label', 'Pause slideshow');
        pauseBtn.classList.remove('is-paused');
      } else {
        flkty.pausePlayer();
        pauseBtn.setAttribute('aria-label', 'Play slideshow');
        pauseBtn.classList.add('is-paused');
      }
      isPaused = !isPaused;
    });
  }

  // Process slideshows once they're ready. Flickity initializes in
  // connectedCallback, so we poll briefly after DOM content is loaded.
  function init() {
    var slideshows = document.querySelectorAll('slide-show');
    slideshows.forEach(function (el) {
      if (el.flkty) {
        addPauseButton(el);
      } else {
        // Flickity may not be ready yet — retry briefly
        var attempts = 0;
        var interval = setInterval(function () {
          attempts++;
          if (el.flkty) {
            clearInterval(interval);
            addPauseButton(el);
          } else if (attempts > 20) {
            clearInterval(interval);
          }
        }, 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOMContentLoaded already fired — wait a tick for custom elements
    setTimeout(init, 100);
  }
})();
